import { internalApiClient } from '@/shared/api-client/internal-api-client';

export async function exportScrapingRunResults(runId: string): Promise<string> {
  const response = await internalApiClient.get(`scraping-runs/${runId}/results/export`);

  return response.text();
}
